export const useMakeWritable = (arr: number[][]): number[][] => {
  const newArr: number[][] = []
  arr.forEach((item) => newArr.push([...item]))
  return newArr
}
